//Please add the language resource
const manualSplitting = {
  orderNo:'订单号',
  customerName:'租赁方',
  consigneeName:'收货方',
  skuCode:'箱型',
  splitQty:'可拆分数量',
  originalQuantity:'原数量',
  subOrderQuantity: '子单数量',
  quantity: '数量',

  nodeName: '审批节点',
  approveUserName: '审批人',
  approveTime: '处理时间',
  approveComment: '审批意见',
  approveStatusName: '审批结果',
  msg:{
  }
};
export default manualSplitting



// WEBPACK FOOTER //
// ./src/page/order/manualSplitting/lang/manualSplitting.en.js